import React, { CSSProperties, ReactNode } from 'react';
import { FontColor } from 'shared/styles/typography';
import CustomTag from '../CustomTag/CustomTag';
import './TextBody.scss';

interface TextBodyInterface {
  component: string;
  children: ReactNode;
  color?: FontColor;
  size?: string;
  bold?: boolean;
  style?: CSSProperties;
  className?: string;
  href?: string;
}

const TextBody = ({ component, color, size, bold = false, children, style, className, href }: TextBodyInterface) => {
  const classNames = `TextBody__text TextBody__text--${color} TextBody__text--${size} ${className}`;

  return (
    <CustomTag tag={component} className={classNames} style={{ ...style, fontWeight: bold ? 'bold' : 'normal' }} href={href}>
      {children}
    </CustomTag>
  );
};

export default TextBody;
